import { COMMIT_SELECTIONS } from "state/selections/actionTypes";
import {
  RECEIVE_DATA,
  REQUEST_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import { SummaryType } from "@ls/grouping-service";
import produce from "immer";
import {
  removeDefinitionFromState,
  setDefinitionToState,
} from "state/grid/utils";
import { DELETE_COLUMN } from "state/grid/actions";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [],
    [SelectionState.COMMITTED]: [],
  },
  fetchingData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  data: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  perfReturnValues: [
    "TOTAL_RETURN_CURRENT_DAY",
    "TOTAL_RETURN_PRIOR_DAY",
    "TOTAL_RETURN_WTD",
    "TOTAL_RETURN_MTD",
    "TOTAL_RETURN_QTD",
    "TOTAL_RETURN_YTD",
    "TOTAL_RETURN_CYTD",
    "TOTAL_RETURN_FYTD",
    "TOTAL_RETURN_WKROLL",
    "TOTAL_RETURN_1MTH",
    "TOTAL_RETURN_3MTHS",
    "TOTAL_RETURN_6MTHS",
    "TOTAL_RETURN_1YR",
    "TOTAL_RETURN_2YRS",
    "TOTAL_RETURN_3YRS",
    "TOTAL_RETURN_4YRS",
    "TOTAL_RETURN_5YRS",
    "TOTAL_RETURN_6YRS",
    "TOTAL_RETURN_7YRS",
    "TOTAL_RETURN_8YRS",
    "TOTAL_RETURN_9YRS",
    "TOTAL_RETURN_10YRS",
    "TOTAL_RETURN_INCEPTION",
    "TOTAL_RETURN_2YRS_ANNUALIZED",
    "TOTAL_RETURN_3YRS_ANNUALIZED",
    "TOTAL_RETURN_4YRS_ANNUALIZED",
    "TOTAL_RETURN_5YRS_ANNUALIZED",
    "TOTAL_RETURN_6YRS_ANNUALIZED",
    "TOTAL_RETURN_7YRS_ANNUALIZED",
    "TOTAL_RETURN_8YRS_ANNUALIZED",
    "TOTAL_RETURN_9YRS_ANNUALIZED",
    "TOTAL_RETURN_10YRS_ANNUALIZED",
    "TOTAL_RETURN_INCEPTION_ANNUALIZED",
  ],
};

const reducer = produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      return setDefinitionToState(state, action.idx, action.definition);
    }

    case DELETE_COLUMN: {
      return removeDefinitionFromState(state, action.payload);
    }

    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }

    case COMMIT_SELECTIONS:
      state.data = defaultState.data;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;

    case REQUEST_DATA:
      state.fetchingData[action.payload.summary] = true;
      state.data[action.payload.summary] =
        defaultState.data[action.payload.summary];
      break;

    case RECEIVE_DATA:
      state.fetchingData[action.payload.summary] = false;
      state.data[action.payload.summary] = action.payload.data;
      break;
    default:
      return state;
  }
});

export default reducer;
